import React from 'react';
import { NavLink } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';

/** Run a build and browse what earlier builds produced live side by side under one menu entry. */
export default function BuildsTabs() {
  const { language } = useLanguage();
  const t = translations[language];
  const item = ({ isActive }) => `segmented__item${isActive ? ' is-active' : ''}`;
  return <nav className="segmented" aria-label={t.navBuilds}>
    <NavLink to="/builder" className={item}>{t.build}</NavLink>
    <NavLink to="/downloads" className={item}>{t.downloads}</NavLink>
  </nav>;
}
